import { render, staticRenderFns } from "./StudioPreparingModal.vue?vue&type=template&id=ba3ce252&scoped=true&"
import script from "./StudioPreparingModal.vue?vue&type=script&lang=js&"
export * from "./StudioPreparingModal.vue?vue&type=script&lang=js&"
import style0 from "./StudioPreparingModal.vue?vue&type=style&index=0&id=ba3ce252&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba3ce252",
  null
  
)

export default component.exports